/**
 * Custom modal trigger element
 */
export var ModalMarkup;
(function (ModalMarkup) {
    ModalMarkup["H1"] = "h1";
    ModalMarkup["H2"] = "h2";
    ModalMarkup["H3"] = "h3";
    ModalMarkup["H4"] = "h4";
    ModalMarkup["H5"] = "h5";
    ModalMarkup["H6"] = "h6";
    ModalMarkup["P"] = "p";
    ModalMarkup["SPAN"] = "span";
    ModalMarkup["DIV"] = "div";
    ModalMarkup["BUTTON"] = "button";
    ModalMarkup["A"] = "a";
})(ModalMarkup || (ModalMarkup = {}));
export var ModalCtaMarkup;
(function (ModalCtaMarkup) {
    ModalCtaMarkup["BUTTON"] = "button";
    ModalCtaMarkup["DIV"] = "div";
    ModalCtaMarkup["A"] = "a";
})(ModalCtaMarkup || (ModalCtaMarkup = {}));
export var ModalSize;
(function (ModalSize) {
    ModalSize["SMALL"] = "small";
    ModalSize["MEDIUM"] = "medium";
    ModalSize["LARGE"] = "large";
})(ModalSize || (ModalSize = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTW9kYWxFbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vY29tcG9uZW50cy9tb2RhbC9Nb2RhbEVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxXQVlYO0FBWkQsV0FBWSxXQUFXO0lBQ3JCLHdCQUFTLENBQUE7SUFDVCx3QkFBUyxDQUFBO0lBQ1Qsd0JBQVMsQ0FBQTtJQUNULHdCQUFTLENBQUE7SUFDVCx3QkFBUyxDQUFBO0lBQ1Qsd0JBQVMsQ0FBQTtJQUNULHNCQUFPLENBQUE7SUFDUCw0QkFBYSxDQUFBO0lBQ2IsMEJBQVcsQ0FBQTtJQUNYLGdDQUFpQixDQUFBO0lBQ2pCLHNCQUFPLENBQUE7QUFDVCxDQUFDLEVBWlcsV0FBVyxLQUFYLFdBQVcsUUFZdEI7QUFJRCxNQUFNLENBQU4sSUFBWSxjQUlYO0FBSkQsV0FBWSxjQUFjO0lBQ3hCLG1DQUFpQixDQUFBO0lBQ2pCLDZCQUFXLENBQUE7SUFDWCx5QkFBTyxDQUFBO0FBQ1QsQ0FBQyxFQUpXLGNBQWMsS0FBZCxjQUFjLFFBSXpCO0FBSUQsTUFBTSxDQUFOLElBQVksU0FJWDtBQUpELFdBQVksU0FBUztJQUNuQiw0QkFBZSxDQUFBO0lBQ2YsOEJBQWlCLENBQUE7SUFDakIsNEJBQWUsQ0FBQTtBQUNqQixDQUFDLEVBSlcsU0FBUyxLQUFULFNBQVMsUUFJcEIifQ==